<template>
	<div id="sprintful-time-select-list" data-cy="visitor-time-list" class="time-list__wrapper">

		<!-- No availability message for selected appointment -->
		<div class="no-times" v-if="!isBookingAvailable">
			<div class="text-center" style="margin-top: 10px">{{ getLocaleText("calendarView.noAvailability", "No Availability") }}</div>
			<p>{{ getLocaleText("calendarView.noSlotForAppointment", "No slot available for this appointment. Try a different appointment from the options on the top or select a different day.") }}</p>
		</div>

		<!-- No availability message for selected date -->
		<div class="no-times" v-else-if="!slots.length">
			<div class="text-center">{{ getLocaleText("calendarView.noAvailability", "No Availability") }}</div>
			<p>{{ getLocaleText("calendarView.noSlotForDay", "No availability on this day. Try a different day from the calendar on the left.") }}</p>
		</div>

		<!-- List of all available time slots for selected date-->
		<ul data-cy="visitor-time-ul-list" class="time-list" v-else-if="slots.length">
			<li class="time-list-item"
				v-for="slot in slots"
				:key="slot.from">
				
				<button class="time-button"
					:data-from="slot.from"
					:data-to="slot.to"
					:disabled="!slot.available"
					:class="{ disabled: !slot.available, 'with-capacity': showAvailableSeats }"
					@mouseover="updateItemHover(slot, true)"
					@mouseout="updateItemHover(slot, false)"
					:style="slot.hover && hoverStyle"
					@click="selectSlot(slot)">
					{{ slot.from | timeFormat(timezone, isTime24) }}
					<span v-if="showAvailableSeats" class="sprintful-available-seats">{{ slot.availableSeatsCount }} seats</span>
				</button>
			</li>
		</ul>

	</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import calendarViewSpecific from "../../mixins/calendarViewSpecific.js"
import {localization} from "../../mixins/localization.js"

export default {
	mixins: [calendarViewSpecific, localization],

	computed: {
		...mapGetters([
			'brandingData',
			'schedulingData',
			'date',
			'events',
			'timezone',
			'selectedAppointment',
			'availabilitySlots',
			'selectedSlot',
			'isSlotAvailable',
			'isBookingAvailable',
			'isTime24',
			'calendarData',
		]),

		hoverStyle() {

			let borderColor = this.brandingData.primaryColor;
			let backgroundColor = this.$root.hexToRgbA(this.brandingData.primaryColor, 0.3);
			
			if (borderColor.toLowerCase() == "#ffffff")
			{
				borderColor = this.brandingData.secondaryColor;
				backgroundColor = "#EEEEEE";
			}

			return {
				borderColor: borderColor,
				backgroundColor: backgroundColor,
			};
		},

		showAvailableSeats() {
			return this.calendarData.settings.scheduling.showAvailableSeats || false;
		},
	},

	filters: {
		timeFormat(val, timezone, isTime24=false) {
			let format = isTime24 ? 'HH:mm' : 'hh:mm a'
			return moment(val)
					.tz(timezone)
					.format(format);
		},

		getTimezone(val, timezone) {
			return moment.tz(timezone);
		},

		dateFormat(val) {
			if (moment.isMoment(val)) {
				return val.format('DD/MM/YYYY');
			}
			return val;
		}
	},

	methods: {
		updateItemHover(item, val) {
			item.hover = val;
			this.$forceUpdate();
		},

		...mapMutations([
			'setIsSlotAvailable',
			'setSelectedSlot',
			'setActiveView',
			'setIsBookingAvailable'
		]),

		selectSlot(slot) {
			this.setSelectedSlot(slot);
			this.setActiveView("booking");
		}
	}

}
</script>

<style>
.time-list__wrapper {
	display: flex;
	flex-grow: 1;
	overflow: hidden;
	margin-top: 2vh;
}

.time-list {
	padding: 0px 12px 12px 0;
	overflow-y: scroll;
}

.time-list::-webkit-scrollbar {
	width: 7px;
}

.time-list::-webkit-scrollbar-thumb {
	border-radius: 4px;
	background: #888;
}

.time-list-item {
	list-style-type: none;
	margin-bottom: 10px;
	direction: ltr;
}

.time-list-item button {
	width: 320px;
}

.no-times {
	padding: 30px;
	color: #ccc;
}

.no-times div {
	font-weight: bold;
	margin-top: 10px;
	margin-bottom: 10px;
}

.no-times p {
	font-size: 14px;
	line-height: 180%;
}

.time-button {
	position: relative;
	display: inline-block;
	border: 1px solid #ccc;
	background-color: #fff;
	padding: 1rem 2rem;
	border-radius: 3px;
	margin: 0;
	text-decoration: none;
	font-size: 1rem;
	line-height: 1;
	cursor: pointer;
	text-align: center;
	transition: background 150ms ease-in-out, transform 150ms ease;
	-webkit-appearance: none;
	-moz-appearance: none;
}
.time-button.with-capacity {
	display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 1rem 4rem;
}

.time-button.with-capacity .sprintful-available-seats {
	position: unset;
}

.time-button.disabled {
	background-color: #f5f5f5;
	cursor: not-allowed;
}

.time-button:active {
	transform: scale(0.99);
}

.sprintful-available-seats {
	font-weight: 100;
	color: #888;
	position: absolute;
	top: 5px;
	right: 5px;
}

@media(max-width: 480px) {

	.time-list {
		width: 100%;
	}

	.time-list-item button {
		width: 100%;
	}
}
</style>